import {Component, Input, OnInit} from '@angular/core';
import {EmisorService} from '../recursos/servicios/emisor.service';
import {UtilConfig} from '../../../../../autenticacion/servicios/UtilConfig';
import {Router} from '@angular/router';
import {MatSnackBar} from '@angular/material';
import {Emisor} from 'app/layout/content/seguridad/emisor/recursos/modelo/emisor';

declare var swal: any;

declare const $: any;


@Component({
    selector: 'cmp-conf-adicional',
    templateUrl: './view/cmp-conf-adicional.component.html',
    styleUrls: ['./css/cmp-conf-adicional.component.scss'],
    providers: [EmisorService]
})
export class CmpConfAdicionalComponent implements OnInit {
    loading = false;
    @Input() emisor: Emisor;
    empresaAdmin = false;
    urlBack;
    @Input() listCloudServiceID: any[];

    constructor(private emisorService: EmisorService,
                private router: Router,
                private util: UtilConfig,
                public snackBar: MatSnackBar) {
        this.urlBack = this.util.URL_WS_BACKEND;

        const empresa = this.util.getCurrentUser().customer.id;
        if (empresa.toString() === this.util.ESCON_CUSTOMER.toString()) {
            this.empresaAdmin = true;
        }
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/cmp-conf-adicional/cmp-conf-adicional.component.ts